import React, { Fragment } from "react";

const Experiences = () => {
  return (
    <Fragment>
      <div className="experience_experience__USIwr">
        <div className="experience_heading__LeH28">
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span className="experience_title__hai7S">
                Dignizant Technologies LLP
              </span>
            </div>
            <div className="overlay" />
          </div>
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span>OCT 2023 - Present</span>
            </div>
            <div className="overlay" />
          </div>
        </div>
        <div className="experience_heading__LeH28">
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span className="experience_position__E06bW">
                MERN Stack Developer
              </span>
            </div>
            <div className="overlay" />
          </div>
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span>Surat</span>
            </div>
            <div className="overlay" />
          </div>
        </div>
        <div
          style={{
            position: "relative",
            width: "fit-content",
            overflow: "hidden",
          }}
        >
          <div className="content">
            <p className="experience_description__iz3mi">
              Over the past 2+ years, I have gained professional experience as a
              MERN Stack Developer, contributing to large-scale industrial
              projects and building dynamic web applications.
            </p>
          </div>
          <div className="overlay" />
        </div>
        <div
          style={{
            position: "relative",
            width: "fit-content",
            overflow: "hidden",
          }}
        >
          <div className="content">
            <div className="experience_tech__jTuus">
              <span className="chip">NextJS</span>
              <span className="chip">SvelteJS</span>
              <span className="chip">ReactJS</span>
              <span className="chip">PostgreSQL</span>
              <span className="chip">GraphQL</span>
              <span className="chip">Redis</span>
              <span className="chip">React Query</span>
              <span className="chip">Docker</span>
              <span className="chip">Cypress</span>
              <span className="chip">Supabase</span>
              <span className="chip">FCM</span>
              <span className="chip">LiveKit</span>
            </div>
          </div>
          <div className="overlay" />
        </div>
      </div>
      <div className="experience_experience__USIwr">
        <div className="experience_heading__LeH28">
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span className="experience_title__hai7S">Brototype</span>
            </div>
            <div className="overlay" />
          </div>
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span>DEC 2022 - AUG 2023</span>
            </div>
            <div className="overlay" />
          </div>
        </div>
        <div className="experience_heading__LeH28">
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span className="experience_position__E06bW">
                MERN Stack Developer Intern
              </span>
            </div>
            <div className="overlay" />
          </div>
          <div
            style={{
              position: "relative",
              width: "fit-content",
              overflow: "hidden",
            }}
          >
            <div className="content">
              <span>Kerala</span>
            </div>
            <div className="overlay" />
          </div>
        </div>
        <div
          style={{
            position: "relative",
            width: "fit-content",
            overflow: "hidden",
          }}
        >
          <div className="content">
            <p className="experience_description__iz3mi">
              Learned Full Stack Web Development using MERN Stack and developed
              multiple projects including E-Commerce and Community Web app.
            </p>
          </div>
          <div className="overlay" />
        </div>
        <div
          style={{
            position: "relative",
            width: "fit-content",
            overflow: "hidden",
          }}
        >
          <div className="content">
            <div className="experience_tech__jTuus">
              <span className="chip">NodeJS</span>
              <span className="chip">ExpressJS</span>
              <span className="chip">ReactJS</span>
              <span className="chip">Redux-Toolkit</span>
              <span className="chip">GitTool</span>
              <span className="chip">Data Structures &amp; Algorithms</span>
              <span className="chip">MongoDB</span>
              <span className="chip">postgreSQL</span>
              <span className="chip">Firebase</span>
            </div>
          </div>
          <div className="overlay" />
        </div>
      </div>
    </Fragment>
  );
};

export default Experiences;
